import {
  Col,
  Descriptions,
  type DescriptionsProps,
  Row,
  Space,
  Typography,
} from 'antd';
import type React from 'react';
import styled from 'styled-components';

const StyledDescriptions = styled(Descriptions)`
  &&& {
    .ant-descriptions-header {
      margin-bottom: 6px;
    }
    .ant-descriptions-item-label {
      font-size: 16px;
      /* font-weight: 600; */
      color: ${({ theme }) => theme.colorTextSecondary};
    }
    .ant-descriptions-item-content {
      font-size: 16px;
      /* font-weight: 600; */
    }
    .ant-descriptions-view {
      /* border-top: 1px solid ${({ theme }) => theme.colorSplit}; */
      /* border-bottom: 1px solid ${({ theme }) => theme.colorSplit}; */
      /* padding-top: 7px; */
    }
  }
`;

export interface IDescriptionsGroupProps {
  title?: React.ReactNode;
  items?: DescriptionsProps['items'];
  compact?: boolean;
}

/**
 * Componente per la visualizzazione di info generiche.
 */
export function DescriptionsGroup(props: IDescriptionsGroupProps) {
  const { title, items, compact } = props;
  if (!items) return null;
  return (
    <div>
      {compact ? (
        <Row>
          {items.map((item, i) => (
            <Col key={`item-${i}`} span={8}>
              <Space>
                <Typography.Text type="secondary">
                  {item.label}:
                </Typography.Text>
                <Typography.Text strong>{item.children}</Typography.Text>
              </Space>
            </Col>
          ))}
        </Row>
      ) : (
        <StyledDescriptions
          // bordered
          title={title}
          size="small"
          items={items}
          column={2}
        />
      )}
    </div>
  );
}
